import { EmployeesTemporalFilter } from "src/models/tna/tna-config/employees-temporal-filter";
import { ListSortDirection, Sort } from "../../models/api/sort";
import { CustomDate } from "../../models/custom-date/custom-date";
import { EmployeeTemporalFilter } from "../../models/employees/employee-filter";
import { TnAEmployeeActualConfigDTO, TnAEmployeeConfigDTO, TnAEmployeeConfigSTO } from "../../models/tna";

import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { BaseApiService } from "../base/base-api.service";

export class TnAEmployeeConfigApiService extends BaseApiService<TnAEmployeeConfigDTO, TnAEmployeeConfigSTO> {
  constructor() {
    super({
      servicePath: "/TnAConfig",
      loadItemsPath: "/GetTnAEmployeesConfig",
      saveItemsPath: "/SaveTnAEmployeesConfig",
    });

    this.defaultSort = [
      {
        name: "employee.name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}

export const loadTnAEmployeeConfig = async (signal: AbortSignal, propsFilter: EmployeesTemporalFilter) => {
  const serviceApi = new TnAEmployeeConfigApiService();

  serviceApi.useLoadItemsPath("/GetTnAEmployeesConfigHistory");

  const response = await serviceApi.loadItems(
    {
      ...propsFilter,
    } as EmployeesTemporalFilter,
    undefined,
    undefined,
    undefined,
    undefined,
    60,
    signal
  );

  return response;
};

export const saveTnAEmployeeConfig = async (tnAEmployeeConfig: TnAEmployeeConfigSTO) => {
  const serviceApi = new TnAEmployeeConfigApiService();

  const response = await serviceApi.saveItems([tnAEmployeeConfig]);

  toastifyResponse(response, "all", "default_success_message", "failure_saving_data", "error_saving_data");

  return response;
};

export class TnAEmployeeActualConfigApiService extends BaseApiService<
  TnAEmployeeActualConfigDTO,
  TnAEmployeeConfigSTO
> {
  constructor() {
    super({
      servicePath: "/TnAConfig",
      loadItemsPath: "/GetTnAEmployeeActualConfig",
      saveItemsPath: "",
    });

    this.defaultSort = [
      {
        name: "employee.name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}

export const loadEETnAActualConfig = async (
  employeeId: string,
  atDate: CustomDate,
  signal: AbortSignal | undefined
) => {
  const apiService = new TnAEmployeeActualConfigApiService();

  const response = await apiService.loadItems(
    {
      employeeId,
      atDate,
    } as EmployeeTemporalFilter,
    undefined,
    [
      {
        name: "employee.name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ],
    undefined,
    undefined,
    undefined,
    signal
  );

  toastifyResponse(response, "failed");

  return response;
};
